export default import.meta.ROLLDOWN_FILE_URL_8KByd7W0oH8zGe1MvrBFUw + "?dataUrl"